module.exports = __webpack_public_path__ + "img/ob-logo-foot.7c8b9e69.png";